import { Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { AlertaDto } from '../../modelo/dto/AlertaDto';

interface IProps {
    alertas: AlertaDto[];
}

export const ViewAlertas = observer(class ViewAlertas extends React.Component<IProps> {
    render() {
        return (
            <div>
                {this.props.alertas?.length > 0 &&
                    <div>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={4}>Alertas:</Typography>
                        <ul>
                            {this.props.alertas.map((alerta, index) => <li key={index + alerta.alerta.descricaoAlerta}>{alerta.alerta.descricaoAlerta}</li>)}
                        </ul>
                    </div>
                }
            </div>
        );
    }
});
